import { OrgMember } from '@/types/auth';

/**
 * Resolve a user id to a human-friendly display name using the org users map
 * from `useOrgUsersMapQuery`. Prefers the full name, then email, then the raw
 * id; returns '-' when there is no id. Shared by the evaluation runs list and
 * the run results page.
 */
export function getUserDisplayName( usersMap: Map<string, OrgMember> | undefined, userId?: string ): string {
  if ( !userId ) return '-';

  const user = usersMap?.get( userId );
  return user?.name || user?.email || userId;
}
